import styled from 'styled-components'
import {darkGray} from '@modifi/colors'

export const Description = styled.div`
  color: ${darkGray};
  text-align: center;
  line-height: 1.5;
  font-size: 16px;
`
